import { render, staticRenderFns } from "./DeliveryPriceStrike.vue?vue&type=template&id=c0e42d5a&scoped=true&"
import script from "./DeliveryPriceStrike.vue?vue&type=script&lang=js&"
export * from "./DeliveryPriceStrike.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPriceStrike.vue?vue&type=style&index=0&id=c0e42d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e42d5a",
  null
  
)

export default component.exports